import { useTranslation } from 'react-i18next'
import React from 'react'
import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import NumberInput from '../../../../../../components/form/NumberInput'
import MinicrudSelect from '../../../../../../containers/minicruds/select/MinicrudSelect'
import ChecklistSelect from '../../../../../../containers/checklists/select/ChecklistSelect'

const GeneralSection = () => {
  const { t } = useTranslation('webhook')

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label={t('stays.name')} field="name" />
      </Col>

      <Col width="100%" wrapOn="sm">
        <FormItem label={t('stays.maxRequests')} field="amountLeft" Input={NumberInput} />
      </Col>

      <Col width="50%" wrapOn="sm">
        <FormItem
          label={t('stays.cancelReason')}
          path={['payload', 'reason']}
          Input={MinicrudSelect}
          entity="canceled"
        />
      </Col>

      <Col width="50%" wrapOn="sm">
        <FormItem label={t('stays.questionnaire')} path={['payload', 'question']} Input={ChecklistSelect} />
      </Col>
    </Grid>
  )
}

export default GeneralSection
